import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import ResumeBuilder from "./ResumeBuilder";
import DocumentConverter from "./DocumentConverter";

export default function App() {
  return (
    <Router>
      <div className="p-4 space-y-4">
        <h1 className="text-2xl font-bold">Document Helper</h1>
        <nav className="space-x-4">
          <Link to="/" className="text-blue-600">Home</Link>
          <Link to="/resume" className="text-blue-600">Resume Builder</Link>
          <Link to="/convert" className="text-blue-600">Document Converter</Link>
        </nav>
        <Routes>
          <Route path="/" element={<div>Welcome to the Document Helper</div>} />
          <Route path="/resume" element={<ResumeBuilder />} />
          <Route path="/convert" element={<DocumentConverter />} />
        </Routes>
      </div>
    </Router>
  );
}
